import React from 'react';
import { Box, Button, Stack, Typography, Paper } from '@mui/material';


// Quick navigation component
export const QuickNavigation: React.FC = () => {
    const scrollToSection = (id: string) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };
  
    return (
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          bgcolor: 'background.paper',
          py: 2,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{ px: 2 }}
          justifyContent="center"
        >
          <Button variant="outlined" onClick={() => scrollToSection('team-overview')}>
            Team
          </Button>
          <Button variant="outlined" onClick={() => scrollToSection('offense')}>
            Offense
          </Button>
          <Button variant="outlined" onClick={() => scrollToSection('defense')}>
            Defense
          </Button>
          <Button variant="outlined" onClick={() => scrollToSection('special-teams')}>
            Special Teams
          </Button>
        </Stack>
      </Box>
    );
  };
  